// actions
export const SEARCH_GROUP = 'SEARCH_GROUP';
export const SEARCH_CONTACT = 'SEARCH_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const DELETE_GROUP = 'DELETE_GROUP';
// mutations
export const GET_LIST_OF_GROUP_CONTACT = 'GET_LIST_OF_GROUP_CONTACT';
export const RESET_CONTACT_AND_GROUP_SEARCHED = 'RESET_CONTACT_AND_GROUP_SEARCHED';
